import {
  GET_HARDNESS_TEST_REQUEST,
  GET_HARDNESS_TEST_SUCCESS,
  GET_HARDNESS_TEST_FAILURE,
  DELETE_HARDNESS_TEST_REQUEST,
  DELETE_HARDNESS_TEST_SUCCESS,
  DELETE_HARDNESS_TEST_FAILURE,
  CREATE_HARDNESS_TEST_REQUEST,
  CREATE_HARDNESS_TEST_SUCCESS,
  CREATE_HARDNESS_TEST_FAILURE,
  EDIT_HARDNESS_TEST_REQUEST,
  EDIT_HARDNESS_TEST_SUCCESS,
  EDIT_HARDNESS_TEST_FAILURE,
  UPLOADCSV_HARDNESS_TEST_REQUEST,
  UPLOADCSV_HARDNESS_TEST_SUCCESS,
  UPLOADCSV_HARDNESS_TEST_FAILURE,
  UPLOADCSV_TENSILE_TEST_REQUEST,
  UPLOADCSV_TENSILE_TEST_SUCCESS,
  UPLOADCSV_TENSILE_TEST_FAILURE,

} from "./hardnessTypes";

import axios from "axios";
import Config from "../../../config/index";
let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

// --- GET API ---
const getHardnessTestRequest = () => ({ type: GET_HARDNESS_TEST_REQUEST });
const getHardnessTestSuccess = (payload) => ({
  type: GET_HARDNESS_TEST_SUCCESS,
  payload,
});
const getHardnessTestFailure = (error) => ({
  type: GET_HARDNESS_TEST_FAILURE,
  payload: error,
});

const getHardnessTest = (dppId, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(getHardnessTestRequest());

    let url = dppId
      ? `${baseUrl}/dpp/hardness_test/get_dpp?dppId=${dppId}`
      : `${baseUrl}/dpp/hardness_test/get_all`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getHardnessTestSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getHardnessTestFailure(err.message));
      });
  };
};

// --- DELETE API ---
const deleteHardnessTestRequest = () => ({
  type: DELETE_HARDNESS_TEST_REQUEST,
});
const deleteHardnessTestSuccess = (payload) => ({
  type: DELETE_HARDNESS_TEST_SUCCESS,
  payload,
});
const deleteHardnessTestFailure = (error) => ({
  type: DELETE_HARDNESS_TEST_FAILURE,
  payload: error,
});

const deleteHardnessTest = (hardnessTestId, udBy, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(deleteHardnessTestRequest());
    let url = `${baseUrl}/dpp/hardness_test/delete?hardnessTestId=${hardnessTestId}&udBy=${udBy}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteHardnessTestSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteHardnessTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- CREATE API ---
const createHardnessTestRequest = () => ({
  type: CREATE_HARDNESS_TEST_REQUEST,
});
const createHardnessTestSuccess = (payload) => ({
  type: CREATE_HARDNESS_TEST_SUCCESS,
  payload,
});
const createHardnessTestFailure = (error) => ({
  type: CREATE_HARDNESS_TEST_FAILURE,
  payload: error,
});

const createHardnessTest = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(createHardnessTestRequest());
    let url = `${baseUrl}/dpp/hardness_test/create`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createHardnessTestSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createHardnessTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- EDIT API ---
const editHardnessTestRequest = () => ({ type: EDIT_HARDNESS_TEST_REQUEST });
const editHardnessTestSuccess = (payload) => ({
  type: EDIT_HARDNESS_TEST_SUCCESS,
  payload,
});
const editHardnessTestFailure = (error) => ({
  type: EDIT_HARDNESS_TEST_FAILURE,
  payload: error,
});

const editHardnessTest = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(editHardnessTestRequest());
    let url = `${baseUrl}/dpp/hardness_test/update`;

    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editHardnessTestSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editHardnessTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const uploadCsvForTensileTestRequest = () => ({
  type: UPLOADCSV_TENSILE_TEST_REQUEST,
});

const uploadCsvForTensileTestSuccess = (payload) => ({
  type: UPLOADCSV_TENSILE_TEST_SUCCESS,
  payload: payload,
});

const uploadCsvForTensileTestFailure = (error) => ({
  type: UPLOADCSV_TENSILE_TEST_FAILURE,
  payload: error,
});

const uploadCsvForTensileTest = (payload, jwtToken) => {
  let headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  return (dispatch) => {
    dispatch(uploadCsvForTensileTestRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_tests/upload?testType=tensile`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForTensileTestSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForTensileTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const uploadCsvForHardnessTestRequest = () => ({
  type: UPLOADCSV_HARDNESS_TEST_REQUEST,
});

const uploadCsvForHardnessTestSuccess = (payload) => ({
  type: UPLOADCSV_HARDNESS_TEST_SUCCESS,
  payload: payload,
});

const uploadCsvForHardnessTestFailure = (error) => ({
  type: UPLOADCSV_HARDNESS_TEST_FAILURE,
  payload: error,
});

const uploadCsvForHardnessTest = (payload, jwtToken) => {
  let headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  return (dispatch) => {
    dispatch(uploadCsvForHardnessTestRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_tests/upload?testType=hardness`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForHardnessTestSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForHardnessTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};



export {
  getHardnessTest,
  deleteHardnessTest,
  createHardnessTest,
  editHardnessTest,
  uploadCsvForTensileTest,
  uploadCsvForHardnessTest,
  // getDocumentTypeWithPagination
};
